module.exports = __webpack_public_path__ + "img/outsourced-num-bg.ae7b41d1.png";